(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("hfCPd", function(module, exports) {

$parcel$export(module.exports, "ProductRenderer", function () { return $c8f1f4360d195a9d$export$c89141f320653b45; });
$parcel$export(module.exports, "CustomSectionRenderer", function () { return $c8f1f4360d195a9d$export$d149f16e70f5252c; });
$parcel$export(module.exports, "Provider", function () { return $c8f1f4360d195a9d$export$2881499e37b75b9a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $8u0V4 = parcelRequire("8u0V4");

var $3qnJm = parcelRequire("3qnJm");

var $7KlbQ = parcelRequire("7KlbQ");
parcelRequire("jMbWK");
var $6Bg4D = parcelRequire("6Bg4D");
var $jN3EE = parcelRequire("jN3EE");
var $93mFc = parcelRequire("93mFc");

var $1xf0g = parcelRequire("1xf0g");

var $55MCT = parcelRequire("55MCT");

var $1t9ha = parcelRequire("1t9ha");

var $cq0ZS = parcelRequire("cq0ZS");

var $hBcYV = parcelRequire("hBcYV");

var $bZsVp = parcelRequire("bZsVp");

var $iCR57 = parcelRequire("iCR57");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
var $c8f1f4360d195a9d$export$3b0d6d7590275603 = {};
function $c8f1f4360d195a9d$export$7b42a0094fb00b6e(props) {
    var transformProp = function transformProp(value) {
        if (typeof value === "number") return;
        else return $loT9g.some(value._0);
    };
    return $d3YYW.map(transformProp, props);
}
function $c8f1f4360d195a9d$var$transform(activeVariantId, product) {
    return {
        id: product.id,
        title: product.name,
        link: product.link,
        productType: product.productType,
        categoryId: product.categoryId,
        variants: $i7mYY.map($7KlbQ.getAllVariantsWithPriority(activeVariantId, product), function(variant) {
            return $7KlbQ.toLegacyDTO(product, variant);
        }),
        metadata: product.metadata
    };
}
var $c8f1f4360d195a9d$var$External = {};
function $c8f1f4360d195a9d$var$NavSDK$ProductRenderer(Props) {
    var activeVariantId = Props.activeVariantId;
    var componentId = Props.componentId;
    var data = Props.data;
    var props = Props.props;
    var renderFallback = Props.renderFallback;
    var data$1 = $g85JO.useMemo(function() {
        return $c8f1f4360d195a9d$var$transform(activeVariantId, data);
    }, [
        $7KlbQ.getKey(undefined, data)
    ]);
    var props$1 = $c8f1f4360d195a9d$export$7b42a0094fb00b6e(props);
    return /*#__PURE__*/ $g85JO.createElement($jN3EE.Renderer, {
        componentId: componentId,
        data: data$1,
        renderFallback: renderFallback,
        additionalProps: props$1
    });
}
$c8f1f4360d195a9d$var$NavSDK$ProductRenderer.displayName = "NavSDK.ProductRenderer";
var $c8f1f4360d195a9d$export$c89141f320653b45 = {
    transform: $c8f1f4360d195a9d$var$transform,
    External: $c8f1f4360d195a9d$var$External,
    make: $c8f1f4360d195a9d$var$NavSDK$ProductRenderer
};
var $c8f1f4360d195a9d$var$External$1 = {};
function $c8f1f4360d195a9d$var$NavSDK$CustomSectionRenderer(Props) {
    var componentId = Props.componentId;
    var renderFallback = Props.renderFallback;
    var props = Props.props;
    var props$1 = $c8f1f4360d195a9d$export$7b42a0094fb00b6e(props);
    return /*#__PURE__*/ $g85JO.createElement($jN3EE.Renderer, {
        componentId: componentId,
        renderFallback: renderFallback,
        additionalProps: props$1
    });
}
$c8f1f4360d195a9d$var$NavSDK$CustomSectionRenderer.displayName = "NavSDK.CustomSectionRenderer";
var $c8f1f4360d195a9d$export$d149f16e70f5252c = {
    External: $c8f1f4360d195a9d$var$External$1,
    make: $c8f1f4360d195a9d$var$NavSDK$CustomSectionRenderer
};
function $c8f1f4360d195a9d$var$transform$1(category) {
    return {
        id: category.id,
        title: category.title,
        description: category.description,
        image: $1xf0g.getCategoryImage(category),
        imageWidth: $1xf0g.getCategoryImageSize(category)[0],
        imageHeight: $1xf0g.getCategoryImageSize(category)[1],
        video: $1xf0g.getCategoryVideo(category),
        children: $1xf0g.getChildren(category).map($c8f1f4360d195a9d$var$transform$1)
    };
}
var $c8f1f4360d195a9d$var$External$2 = {};
function $c8f1f4360d195a9d$var$NavSDK$CategoryRenderer(Props) {
    var componentId = Props.componentId;
    var data = Props.data;
    var renderFallback = Props.renderFallback;
    var props = Props.props;
    var data$1 = $g85JO.useMemo(function() {
        return $c8f1f4360d195a9d$var$transform$1(data);
    }, [
        $1xf0g.getKey(data)
    ]);
    var props$1 = $c8f1f4360d195a9d$export$7b42a0094fb00b6e(props);
    return /*#__PURE__*/ $g85JO.createElement($jN3EE.Renderer, {
        componentId: componentId,
        data: data$1,
        renderFallback: renderFallback,
        additionalProps: props$1
    });
}
$c8f1f4360d195a9d$var$NavSDK$CategoryRenderer.displayName = "NavSDK.CategoryRenderer";
var $c8f1f4360d195a9d$export$8ca3c5493b0d9843 = {
    transform: $c8f1f4360d195a9d$var$transform$1,
    External: $c8f1f4360d195a9d$var$External$2,
    make: $c8f1f4360d195a9d$var$NavSDK$CategoryRenderer
};
function $c8f1f4360d195a9d$var$defaultRenderImage(props) {
    var match = props.fit;
    return /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
        src: props.src,
        fit: match === "contain" ? /* Contain */ 2 : match === "scale-down" ? /* ScaleDown */ 0 : /* Cover */ 1,
        alt: props.alt,
        priority: props.priority
    });
}
function $c8f1f4360d195a9d$var$defaultRenderVideo(props) {
    var match = props.fit;
    return /*#__PURE__*/ $g85JO.createElement($1t9ha.make, {
        src: props.src,
        poster: props.poster,
        objectFit: match === "contain" ? "contain" : match === "scale-down" ? "scale-down" : "cover",
        autoplay: props.autoplay,
        loop: props.loop,
        muted: props.muted,
        controls: props.controls
    });
}
function $c8f1f4360d195a9d$var$defaultProductLink(router, props) {
    return /*#__PURE__*/ $g85JO.createElement("a", {
        style: {
            textDecoration: "none"
        },
        href: $2whNH.getWithDefault(props.href, ""),
        onClick: function onClick(e) {
            e.preventDefault();
            $iv6Yc._3(router.goTo, undefined, undefined, {
                TAG: /* PDP */ 2,
                _0: {
                    categoryId: undefined,
                    productCategoryId: props.categoryId,
                    productId: props.productId,
                    variantId: props.variantId,
                    zoomedPhotoIndex: undefined
                }
            });
        }
    }, $2whNH.getWithDefault(props.children, null));
}
function $c8f1f4360d195a9d$var$defaultCategoryLink(router, props) {
    return /*#__PURE__*/ $g85JO.createElement("a", {
        style: {
            textDecoration: "none"
        },
        href: $2whNH.getWithDefault(props.href, ""),
        onClick: function onClick(e) {
            e.preventDefault();
            $iv6Yc._3(router.goTo, undefined, undefined, {
                TAG: /* ListPage */ 1,
                _0: {
                    listPageType: {
                        TAG: /* Category */ 0,
                        _0: props.categoryId
                    },
                    viewPLP: false,
                    filters: undefined,
                    sort: undefined
                }
            });
        }
    }, $2whNH.getWithDefault(props.children, null));
}
function $c8f1f4360d195a9d$var$defaultProductForm(props) {
    var match = $9pMGg.use(undefined);
    var match$1 = $8u0V4.getValues(match.market);
    var match$2 = $8E2YL.use(undefined);
    var product = $bZsVp.getProductById(match.smartnavApiHost, match$1.currency, match$1.country, props.product.id);
    var variant = $2whNH.flatMap($2whNH.map(product, $7KlbQ.getAllVariants), function(variants) {
        return $i7mYY.get(variants, 0);
    });
    if (product !== undefined && variant !== undefined) return /*#__PURE__*/ $g85JO.createElement($3qnJm.make, $3qnJm.makeProps(product, variant, undefined, match$2.config.settings.hideOutOfStock, match.onProductFormChange, match.onProductFormSubmit, props.children, undefined, undefined));
    else return /*#__PURE__*/ $g85JO.createElement("h1", undefined, "Product not found");
}
function $c8f1f4360d195a9d$var$defaultProductVariantPicker(props) {
    return /*#__PURE__*/ $g85JO.createElement($3qnJm.AllFields.make, {
        onRender: function onRender(field, onChange, element) {
            return $iv6Yc._2(props.children, field, onChange);
        }
    });
}
function $c8f1f4360d195a9d$var$defaultProductQuantityPicker(props) {
    return /*#__PURE__*/ $g85JO.createElement($3qnJm.QuantityPicker.make, {
        onRender: props.children
    });
}
function $c8f1f4360d195a9d$var$defaultProductBuyButton(props) {
    var match = $8E2YL.use(undefined);
    var tmp = {};
    if (props.className !== undefined) tmp.className = $loT9g.valFromOption(props.className);
    if (props.style !== undefined) tmp.style = $loT9g.valFromOption(props.style);
    return /*#__PURE__*/ $g85JO.createElement($3qnJm.SubmitButton.make, {
        children: /*#__PURE__*/ $g85JO.createElement("button", tmp, $iv6Yc._1(props.children, "available")),
        label: match.config.settings.pdpAddToCartLabel,
        submitButtonType: /* AddToCart */ 0
    });
}
function $c8f1f4360d195a9d$var$defaultProductInfo(props) {
    var match = $3qnJm.use(undefined);
    var form = match.form;
    var match$1 = form.product;
    var match$2 = form.variant;
    var transformed = match$1 !== undefined && match$2 !== undefined ? $7KlbQ.toLegacyDTO(match$1, match$2) : undefined;
    if (transformed !== undefined) return $iv6Yc._1(props.children, transformed);
    else return null;
}
var $c8f1f4360d195a9d$var$External$3 = {};
function $c8f1f4360d195a9d$var$NavSDK$SharedComponentsProvider(Props) {
    var children = Props.children;
    var router = $hBcYV.useRouter(undefined);
    return /*#__PURE__*/ $g85JO.createElement($93mFc.Provider, {
        renderImage: $c8f1f4360d195a9d$var$defaultRenderImage,
        renderVideo: $c8f1f4360d195a9d$var$defaultRenderVideo,
        renderProductLink: function renderProductLink(param) {
            return $c8f1f4360d195a9d$var$defaultProductLink(router, param);
        },
        renderCategoryLink: function renderCategoryLink(param) {
            return $c8f1f4360d195a9d$var$defaultCategoryLink(router, param);
        },
        renderProductVariantPicker: $c8f1f4360d195a9d$var$defaultProductVariantPicker,
        renderProductForm: $c8f1f4360d195a9d$var$defaultProductForm,
        renderProductQuantityPicker: $c8f1f4360d195a9d$var$defaultProductQuantityPicker,
        renderProductBuyButton: $c8f1f4360d195a9d$var$defaultProductBuyButton,
        renderProductInfo: $c8f1f4360d195a9d$var$defaultProductInfo,
        children: children
    });
}
$c8f1f4360d195a9d$var$NavSDK$SharedComponentsProvider.displayName = "NavSDK.SharedComponentsProvider";
var $c8f1f4360d195a9d$export$89c90df8228b7912 = {
    defaultRenderImage: $c8f1f4360d195a9d$var$defaultRenderImage,
    defaultRenderVideo: $c8f1f4360d195a9d$var$defaultRenderVideo,
    defaultProductLink: $c8f1f4360d195a9d$var$defaultProductLink,
    defaultCategoryLink: $c8f1f4360d195a9d$var$defaultCategoryLink,
    defaultProductForm: $c8f1f4360d195a9d$var$defaultProductForm,
    defaultProductVariantPicker: $c8f1f4360d195a9d$var$defaultProductVariantPicker,
    defaultProductQuantityPicker: $c8f1f4360d195a9d$var$defaultProductQuantityPicker,
    defaultProductBuyButton: $c8f1f4360d195a9d$var$defaultProductBuyButton,
    defaultProductInfo: $c8f1f4360d195a9d$var$defaultProductInfo,
    External: $c8f1f4360d195a9d$var$External$3,
    make: $c8f1f4360d195a9d$var$NavSDK$SharedComponentsProvider
};
function $c8f1f4360d195a9d$var$NavSDK$CustomComponentsLoader(Props) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var componentReferencesInTree = $i7mYY.map($cq0ZS.keepMapCategories(config.categories, function(category) {
        var match = category.categoryType;
        if (typeof match === "number" || match.TAG !== /* CustomComponentSection */ 5) return;
        else return match._0.component;
    }), function(a) {
        return a;
    });
    var componentsToPreload = $i7mYY.concat($i7mYY.concat([
        config.settings.productCardComponent
    ], [
        config.settings.pdpComponent
    ]), componentReferencesInTree);
    return $i7mYY.map($i7mYY.keepMap(componentsToPreload, function(a) {
        return a;
    }), function(component) {
        return /*#__PURE__*/ $g85JO.createElement($6Bg4D.ComponentLoader, {
            url: component.componentUrl,
            key: $iv6Yc._1($iCR57.toString, component.id) + "-" + component.version
        });
    });
}
$c8f1f4360d195a9d$var$NavSDK$CustomComponentsLoader.displayName = "NavSDK.CustomComponentsLoader";
var $c8f1f4360d195a9d$export$b65e378a139ddbe6 = {
    make: $c8f1f4360d195a9d$var$NavSDK$CustomComponentsLoader
};
function $c8f1f4360d195a9d$var$NavSDK$Provider(Props) {
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($c8f1f4360d195a9d$var$NavSDK$SharedComponentsProvider, {
        children: null
    }, /*#__PURE__*/ $g85JO.createElement($c8f1f4360d195a9d$var$NavSDK$CustomComponentsLoader, {}), children);
}
$c8f1f4360d195a9d$var$NavSDK$Provider.displayName = "NavSDK.Provider";
var $c8f1f4360d195a9d$export$2881499e37b75b9a = {
    make: $c8f1f4360d195a9d$var$NavSDK$Provider
};
 /* react Not a pure module */ 
});
parcelRegister("jMbWK", function(module, exports) {

$parcel$export(module.exports, "Renderer", function () { return (parcelRequire("jN3EE")).Renderer; });
$parcel$export(module.exports, "ComponentLoader", function () { return (parcelRequire("6Bg4D")).ComponentLoader; });
$parcel$export(module.exports, "SharedComponentsProvider", function () { return (parcelRequire("93mFc")).Provider; });

var $a22BD = parcelRequire("a22BD");

var $51hbQ = parcelRequire("51hbQ");

var $gT3ZJ = parcelRequire("gT3ZJ");

var $kqP8v = parcelRequire("kqP8v");

var $REi2p = parcelRequire("REi2p");

var $3bP7j = parcelRequire("3bP7j");

var $2nb80 = parcelRequire("2nb80");

var $bo6LR = parcelRequire("bo6LR");

var $fRwqu = parcelRequire("fRwqu");

var $4sjqa = parcelRequire("4sjqa");

var $jN3EE = parcelRequire("jN3EE");

var $6Bg4D = parcelRequire("6Bg4D");

var $93mFc = parcelRequire("93mFc");

});
parcelRegister("a22BD", function(module, exports) {

$parcel$export(module.exports, "registry", function () { return $74dc1cce85668f51$export$4bb7493d241fd8a5; });
$parcel$export(module.exports, "useRegistrationListener", function () { return $74dc1cce85668f51$export$bba9bc1e8f2bb4e1; });
$parcel$export(module.exports, "useRegisteredComponentByUrl", function () { return $74dc1cce85668f51$export$e20fd5fb710d82aa; });

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $kekIc = parcelRequire("kekIc");

var $9fsm9 = parcelRequire("9fsm9");

var $genBR = parcelRequire("genBR");

var $jUZe6 = parcelRequire("jUZe6");
var $74dc1cce85668f51$export$fa3d5b535a2458a1 = {
    REGISTERED: "maker-nav-component-registered",
    UNREGISTERED: "maker-nav-component-unregistered"
};
var $74dc1cce85668f51$var$getCallerModuleUrl = function() {
    var _err_stack;
    var err = new Error();
    var stackLines = ((_err_stack = err.stack) === null || _err_stack === void 0 ? void 0 : _err_stack.split("\n")) || [];
    var lastStackLine = stackLines[stackLines.length - 1];
    if (!lastStackLine) return;
    var match = lastStackLine.match(/.*at\s+(https?:\/\/.*?(\.js|\.tsx|\.ts))(?::\d+:\d+)?.*/);
    if (match) return match[1];
};
var $74dc1cce85668f51$export$cb36105ac80a8b4b = /*#__PURE__*/ function() {
    "use strict";
    function ComponentRegistry() {
        var _this = this;
        (0, $6Tsgf._)(this, ComponentRegistry);
        Object.defineProperty(this, "components", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        if (typeof window === "undefined") return;
        if (typeof document === "undefined") return;
        (0, $genBR.injectImportMap)();
        window.__MAKER_NAV_COMPONENT_REGISTRY__ = {
            register: function(componentType, componentId, render) {
                (0, $jUZe6.log)("registering", componentId);
                var componentUrl = $74dc1cce85668f51$var$getCallerModuleUrl() || "unknown";
                var defaultProps = render.defaultProps;
                _this.components.set(componentId, {
                    componentType: componentType,
                    componentUrl: componentUrl,
                    render: render,
                    defaultProps: defaultProps
                });
                window.dispatchEvent(new CustomEvent($74dc1cce85668f51$export$fa3d5b535a2458a1.REGISTERED, {
                    detail: {
                        componentType: componentType,
                        componentId: componentId,
                        componentUrl: componentUrl,
                        defaultProps: defaultProps
                    }
                }));
            },
            unregister: function(componentId) {
                (0, $jUZe6.log)("unregistering", componentId);
                var component = _this.components.get(componentId);
                if (component) {
                    _this.components.delete(componentId);
                    window.dispatchEvent(new CustomEvent($74dc1cce85668f51$export$fa3d5b535a2458a1.UNREGISTERED, {
                        detail: {
                            componentId: componentId
                        }
                    }));
                }
            },
            list: function() {
                return Array.from(_this.components.entries()).map(function(param) {
                    var _param = (0, $kekIc._)(param, 2), componentId = _param[0], component = _param[1];
                    return {
                        componentId: componentId,
                        componentUrl: component.componentUrl,
                        componentType: component.componentType,
                        render: component.render,
                        defaultProps: component.defaultProps
                    };
                });
            }
        };
    }
    (0, $hmsbi._)(ComponentRegistry, [
        {
            key: "register",
            value: function register(componentType, componentId, render) {
                if (this.isRegistryAvailable()) window.__MAKER_NAV_COMPONENT_REGISTRY__.register(componentType, componentId, render);
            }
        },
        {
            key: "unregister",
            value: function unregister(componentId) {
                if (this.isRegistryAvailable()) window.__MAKER_NAV_COMPONENT_REGISTRY__.unregister(componentId);
            }
        },
        {
            key: "getById",
            value: function getById(componentId) {
                return window.__MAKER_NAV_COMPONENT_REGISTRY__.list().find(function(component) {
                    return component.componentId === componentId;
                });
            }
        },
        {
            key: "getByUrl",
            value: function getByUrl(componentUrl) {
                return window.__MAKER_NAV_COMPONENT_REGISTRY__.list().find(function(component) {
                    return component.componentUrl === componentUrl;
                });
            }
        },
        {
            key: "isRegistryAvailable",
            value: function isRegistryAvailable() {
                return typeof window !== "undefined" && !!window.__MAKER_NAV_COMPONENT_REGISTRY__;
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (typeof window !== "undefined" && window.__MAKER_NAV_COMPONENT_REGISTRY_INSTANCE__) return window.__MAKER_NAV_COMPONENT_REGISTRY_INSTANCE__;
                var instance = new ComponentRegistry();
                if (typeof window !== "undefined") window.__MAKER_NAV_COMPONENT_REGISTRY_INSTANCE__ = instance;
                return instance;
            }
        }
    ]);
    return ComponentRegistry;
}();
var $74dc1cce85668f51$export$4bb7493d241fd8a5 = $74dc1cce85668f51$export$cb36105ac80a8b4b.getInstance();
function $74dc1cce85668f51$export$bba9bc1e8f2bb4e1(callback) {
    var dependencies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    (0, $9fsm9.default).useEffect(function() {
        var handleEvent = function(e) {
            var data = e;
            callback(data.detail);
        };
        window.addEventListener($74dc1cce85668f51$export$fa3d5b535a2458a1.REGISTERED, handleEvent);
        return function() {
            window.removeEventListener($74dc1cce85668f51$export$fa3d5b535a2458a1.REGISTERED, handleEvent);
        };
    }, dependencies);
}
function $74dc1cce85668f51$export$71ca689bdbe59c44(componentId) {
    var initialValue = $74dc1cce85668f51$export$4bb7493d241fd8a5.getById(componentId);
    var _React_useState = (0, $kekIc._)((0, $9fsm9.default).useState(initialValue), 2), registeredComponent = _React_useState[0], setRegisteredComponent = _React_useState[1];
    $74dc1cce85668f51$export$bba9bc1e8f2bb4e1(function(data) {
        data.componentId == componentId && setRegisteredComponent($74dc1cce85668f51$export$4bb7493d241fd8a5.getById(componentId));
    });
    return registeredComponent;
}
function $74dc1cce85668f51$export$e20fd5fb710d82aa(componentUrl) {
    var initialValue = $74dc1cce85668f51$export$4bb7493d241fd8a5.getById(componentUrl);
    var _React_useState = (0, $kekIc._)((0, $9fsm9.default).useState(initialValue), 2), registeredComponent = _React_useState[0], setRegisteredComponent = _React_useState[1];
    $74dc1cce85668f51$export$bba9bc1e8f2bb4e1(function(data) {
        data.componentUrl == componentUrl && setRegisteredComponent($74dc1cce85668f51$export$4bb7493d241fd8a5.getByUrl(componentUrl));
    });
    return registeredComponent;
}

});
parcelRegister("9fsm9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bbb82c13c13909d$export$2e2bcd8739ae039; });

var $g85JO = parcelRequire("g85JO");
parcelRequire("8uvuR");
window.__MAKER_NAV_REACT__ = window.__MAKER_NAV_REACT__ || (0, (/*@__PURE__*/$parcel$interopDefault($g85JO)));
var $6bbb82c13c13909d$export$2e2bcd8739ae039 = window.__MAKER_NAV_REACT__;

});
parcelRegister("8uvuR", function(module, exports) {

});


parcelRegister("genBR", function(module, exports) {

$parcel$export(module.exports, "injectImportMap", function () { return $bd1044897b14359e$export$f3c3e67581ce02a6; });
var $bd1044897b14359e$var$ID = "maker-nav-importmap";
var $bd1044897b14359e$var$MAP = {
    imports: {
        react: "https://esm.sh/react@16.14.0",
        "react-dom": "https://esm.sh/react-dom",
        "react/jsx-runtime": "https://esm.sh/react@16.14.0/jsx-runtime",
        "react-dom/server": "https://esm.sh/react-dom/server"
    }
};
var $bd1044897b14359e$export$f3c3e67581ce02a6 = function() {
    if (typeof window === "undefined") return;
    if (typeof document === "undefined") return;
    if (!!document.getElementById($bd1044897b14359e$var$ID)) return;
    var script = document.createElement("script");
    script.innerHTML = JSON.stringify($bd1044897b14359e$var$MAP);
    script.type = "importmap";
    script.id = $bd1044897b14359e$var$ID;
    document.head.appendChild(script);
};

});

parcelRegister("jUZe6", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $e802bd94de9868ca$export$bef1f36f5486a6a3; });

var $kRmIq = parcelRequire("kRmIq");
var $e802bd94de9868ca$var$loggingEnabled = window.__MAKER_NAV_LOGGING_ENABLED__ || true;
var $e802bd94de9868ca$export$bef1f36f5486a6a3 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    if (!$e802bd94de9868ca$var$loggingEnabled) return;
    (_console = console).log.apply(_console, [
        "[nav-sdk]"
    ].concat((0, $kRmIq._)(args)));
};

});


parcelRegister("51hbQ", function(module, exports) {

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $3a7a615718d7a7c1$var$Image = function(props) {
    var renderImage = (0, $93mFc.default).useContext().renderImage;
    if (typeof renderImage === "function") return renderImage(props);
    return (0, $c9Ozz.jsx)("img", {
        src: props.src,
        alt: props.alt,
        loading: props.priority == 0 ? "eager" : "lazy",
        fetchpriority: props.priority == 0 ? "high" : "low",
        style: {
            objectFit: props.fit,
            objectPosition: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0
        }
    });
};
var $3a7a615718d7a7c1$export$2e2bcd8739ae039 = $3a7a615718d7a7c1$var$Image;

});
parcelRegister("c9Ozz", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3hd0N"));

});
parcelRegister("3hd0N", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $262d0d7f63a884cc$export$ffb0004e005737fa; }, function (v) { return $262d0d7f63a884cc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $262d0d7f63a884cc$export$34b9dba7ce09269b; }, function (v) { return $262d0d7f63a884cc$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $262d0d7f63a884cc$export$25062201e9e25d76; }, function (v) { return $262d0d7f63a884cc$export$25062201e9e25d76 = v; });
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $262d0d7f63a884cc$export$ffb0004e005737fa;
var $262d0d7f63a884cc$export$34b9dba7ce09269b;
var $262d0d7f63a884cc$export$25062201e9e25d76;
"use strict";

var $g85JO = parcelRequire("g85JO");
var $262d0d7f63a884cc$var$g = 60103;
$262d0d7f63a884cc$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $262d0d7f63a884cc$var$h = Symbol.for;
    $262d0d7f63a884cc$var$g = $262d0d7f63a884cc$var$h("react.element");
    $262d0d7f63a884cc$export$ffb0004e005737fa = $262d0d7f63a884cc$var$h("react.fragment");
}
var $262d0d7f63a884cc$var$m = $g85JO.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $262d0d7f63a884cc$var$n = Object.prototype.hasOwnProperty, $262d0d7f63a884cc$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $262d0d7f63a884cc$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$262d0d7f63a884cc$var$n.call(a, b) && !$262d0d7f63a884cc$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $262d0d7f63a884cc$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $262d0d7f63a884cc$var$m.current
    };
}
$262d0d7f63a884cc$export$34b9dba7ce09269b = $262d0d7f63a884cc$var$q;
$262d0d7f63a884cc$export$25062201e9e25d76 = $262d0d7f63a884cc$var$q;

});


parcelRegister("93mFc", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $6975f958102cb39b$export$2881499e37b75b9a; });
$parcel$export(module.exports, "default", function () { return $6975f958102cb39b$export$2e2bcd8739ae039; });

var $1Fvp9 = parcelRequire("1Fvp9");

var $c9Ozz = parcelRequire("c9Ozz");

var $9fsm9 = parcelRequire("9fsm9");
window.__MAKER_NAV_SHARED_COMPONENTS_CONTEXT__ = window.__MAKER_NAV_SHARED_COMPONENTS_CONTEXT__ || (0, $9fsm9.default).createContext({
    renderImage: undefined,
    renderVideo: undefined,
    renderProductLink: undefined,
    renderCategoryLink: undefined,
    renderProductBuyButton: undefined,
    renderProductForm: undefined,
    renderProductVariantPicker: undefined,
    renderProductQuantityPicker: undefined,
    renderProductInfo: undefined,
    renderProductFavoriteButton: undefined
});
var $6975f958102cb39b$var$Context = window.__MAKER_NAV_SHARED_COMPONENTS_CONTEXT__;
var $6975f958102cb39b$export$fae74005e78b1a27 = function() {
    return (0, $9fsm9.default).useContext($6975f958102cb39b$var$Context);
};
function $6975f958102cb39b$export$2881499e37b75b9a(_param) {
    var children = _param.children, ctxValue = (0, $1Fvp9._)(_param, [
        "children"
    ]);
    return (0, $c9Ozz.jsx)($6975f958102cb39b$var$Context.Provider, {
        value: ctxValue,
        children: children
    });
}
var $6975f958102cb39b$export$2e2bcd8739ae039 = {
    Provider: $6975f958102cb39b$export$2881499e37b75b9a,
    useContext: $6975f958102cb39b$export$fae74005e78b1a27
};

});


parcelRegister("gT3ZJ", function(module, exports) {

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $c4b4e1adb48761f2$var$Video = function(props) {
    var renderVideo = (0, $93mFc.default).useContext().renderVideo;
    if (typeof renderVideo === "function") return renderVideo(props);
    return (0, $c9Ozz.jsx)("video", {
        src: props.src,
        autoPlay: props.autoplay,
        poster: props.poster,
        controls: props.controls,
        muted: props.muted,
        loop: props.loop,
        style: {
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            objectFit: props.fit
        }
    });
};
var $c4b4e1adb48761f2$export$2e2bcd8739ae039 = $c4b4e1adb48761f2$var$Video;

});

parcelRegister("kqP8v", function(module, exports) {

var $gu11n = parcelRequire("gu11n");

var $iiZHH = parcelRequire("iiZHH");

var $1Fvp9 = parcelRequire("1Fvp9");

var $c9Ozz = parcelRequire("c9Ozz");

var $9fsm9 = parcelRequire("9fsm9");

var $93mFc = parcelRequire("93mFc");
var $edfde6f617b5870e$var$Spread = function(param) {
    var props = param.props, children = param.children;
    return (0, $9fsm9.default).cloneElement(children, (0, $gu11n._)({}, props));
};
var $edfde6f617b5870e$var$Link = function(props) {
    if (props.target === "product") return (0, $c9Ozz.jsx)($edfde6f617b5870e$var$ProductLink, (0, $gu11n._)({}, props));
    if (props.target === "category") return (0, $c9Ozz.jsx)($edfde6f617b5870e$var$CategoryLink, (0, $gu11n._)({}, props));
    return (0, $c9Ozz.jsx)($edfde6f617b5870e$var$SimpleLink, (0, $gu11n._)({}, props));
};
var $edfde6f617b5870e$var$SimpleLink = function(_param) {
    var children = _param.children, props = (0, $1Fvp9._)(_param, [
        "children"
    ]);
    return (0, $c9Ozz.jsx)("a", (0, $iiZHH._)((0, $gu11n._)({}, props), {
        children: children
    }));
};
var $edfde6f617b5870e$var$ProductLink = function(_param) {
    var productId = _param.productId, variantId = _param.variantId, categoryId = _param.categoryId, href = _param.href, children = _param.children, target = _param.target, props = (0, $1Fvp9._)(_param, [
        "productId",
        "variantId",
        "categoryId",
        "href",
        "children",
        "target"
    ]);
    var renderProductLink = (0, $93mFc.default).useContext().renderProductLink;
    if (typeof renderProductLink === "function") return (0, $c9Ozz.jsx)($edfde6f617b5870e$var$Spread, {
        props: props,
        children: renderProductLink({
            productId: productId,
            variantId: variantId,
            categoryId: categoryId,
            href: href,
            children: children,
            target: target
        })
    });
    return (0, $c9Ozz.jsx)($edfde6f617b5870e$var$SimpleLink, (0, $iiZHH._)((0, $gu11n._)({
        href: href,
        target: "_top"
    }, props), {
        children: children
    }));
};
var $edfde6f617b5870e$var$CategoryLink = function(_param) {
    var categoryId = _param.categoryId, href = _param.href, children = _param.children, target = _param.target, props = (0, $1Fvp9._)(_param, [
        "categoryId",
        "href",
        "children",
        "target"
    ]);
    var renderCategoryLink = (0, $93mFc.default).useContext().renderCategoryLink;
    if (typeof renderCategoryLink === "function") return (0, $c9Ozz.jsx)($edfde6f617b5870e$var$Spread, {
        props: props,
        children: renderCategoryLink({
            categoryId: categoryId,
            href: href,
            children: children,
            target: target
        })
    });
    return (0, $c9Ozz.jsx)($edfde6f617b5870e$var$SimpleLink, (0, $iiZHH._)((0, $gu11n._)({
        href: href,
        target: "_top"
    }, props), {
        children: children
    }));
};
var $edfde6f617b5870e$export$2e2bcd8739ae039 = $edfde6f617b5870e$var$Link;

});

parcelRegister("REi2p", function(module, exports) {

var $gu11n = parcelRequire("gu11n");

var $iiZHH = parcelRequire("iiZHH");

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $0a143417d9d649d1$var$BuyButton = function(props) {
    var renderProductBuyButton = (0, $93mFc.default).useContext().renderProductBuyButton;
    if (typeof renderProductBuyButton === "function") return renderProductBuyButton(props);
    return (0, $c9Ozz.jsx)("button", (0, $iiZHH._)((0, $gu11n._)({}, props), {
        onClick: props.onClick,
        children: props.children("available")
    }));
};
var $0a143417d9d649d1$export$2e2bcd8739ae039 = $0a143417d9d649d1$var$BuyButton;

});

parcelRegister("3bP7j", function(module, exports) {

var $gu11n = parcelRequire("gu11n");

var $iiZHH = parcelRequire("iiZHH");

var $1Fvp9 = parcelRequire("1Fvp9");

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $252a0cedca1d6ddf$var$ProductForm = function(props) {
    var product = props.product, variant = props.variant, children = props.children, standardFormProps = (0, $1Fvp9._)(props, [
        "product",
        "variant",
        "children"
    ]);
    var renderProductForm = (0, $93mFc.default).useContext().renderProductForm;
    if (typeof renderProductForm === "function") return renderProductForm(props);
    return (0, $c9Ozz.jsx)("form", (0, $iiZHH._)((0, $gu11n._)({}, standardFormProps), {
        children: props.children
    }));
};
var $252a0cedca1d6ddf$export$2e2bcd8739ae039 = $252a0cedca1d6ddf$var$ProductForm;

});

parcelRegister("2nb80", function(module, exports) {

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $1ba65c935df34637$var$VariantPicker = function(props) {
    var renderProductVariantPicker = (0, $93mFc.default).useContext().renderProductVariantPicker;
    if (typeof renderProductVariantPicker === "function") return renderProductVariantPicker(props);
    return (0, $c9Ozz.jsx)("div", {
        children: "variant picker not implemented"
    });
};
var $1ba65c935df34637$export$2e2bcd8739ae039 = $1ba65c935df34637$var$VariantPicker;

});

parcelRegister("bo6LR", function(module, exports) {

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $84a7303162631ec4$var$QuantityPicker = function(props) {
    var renderProductQuantityPicker = (0, $93mFc.default).useContext().renderProductQuantityPicker;
    if (typeof renderProductQuantityPicker === "function") return renderProductQuantityPicker(props);
    return (0, $c9Ozz.jsx)("div", {
        children: "quantity picker not implemented"
    });
};
var $84a7303162631ec4$export$2e2bcd8739ae039 = $84a7303162631ec4$var$QuantityPicker;

});

parcelRegister("fRwqu", function(module, exports) {

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $b8c4f56c2ea27641$var$ProductInfo = function(props) {
    var renderProductInfo = (0, $93mFc.default).useContext().renderProductInfo;
    if (typeof renderProductInfo === "function") return renderProductInfo(props);
    return (0, $c9Ozz.jsx)("div", {
        children: "product info not implemented"
    });
};
var $b8c4f56c2ea27641$export$2e2bcd8739ae039 = $b8c4f56c2ea27641$var$ProductInfo;

});

parcelRegister("4sjqa", function(module, exports) {

var $gu11n = parcelRequire("gu11n");

var $iiZHH = parcelRequire("iiZHH");

var $c9Ozz = parcelRequire("c9Ozz");

var $93mFc = parcelRequire("93mFc");
var $33e8d791f1020d83$var$FavoriteButton = function(props) {
    var renderProductFavoriteButton = (0, $93mFc.default).useContext().renderProductFavoriteButton;
    if (typeof renderProductFavoriteButton === "function") return renderProductFavoriteButton(props);
    return (0, $c9Ozz.jsx)("button", (0, $iiZHH._)((0, $gu11n._)({}, props), {
        onClick: props.onClick,
        children: props.children("toggled-off")
    }));
};
var $33e8d791f1020d83$export$2e2bcd8739ae039 = $33e8d791f1020d83$var$FavoriteButton;

});

parcelRegister("jN3EE", function(module, exports) {

$parcel$export(module.exports, "Renderer", function () { return $e6856dab26f88dc8$export$88530751e3977073; });

var $gu11n = parcelRequire("gu11n");

var $kekIc = parcelRequire("kekIc");

var $c9Ozz = parcelRequire("c9Ozz");

var $g85JO = parcelRequire("g85JO");

var $gDoOy = parcelRequire("gDoOy");

var $a22BD = parcelRequire("a22BD");

var $chcmK = parcelRequire("chcmK");
function $e6856dab26f88dc8$export$88530751e3977073(param) {
    var componentId = param.componentId, data = param.data, additionalProps = param.additionalProps, renderFallback = param.renderFallback;
    var _registry_getById;
    var _React_useState = (0, $kekIc._)((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).useState(function() {
        return 0;
    }), 2), setForceRender = _React_useState[1];
    (0, $a22BD.useRegistrationListener)(function(data) {
        if (data.componentId === componentId) setForceRender(function(previous) {
            return previous + 1;
        });
    });
    var RenderComponent = (_registry_getById = (0, $a22BD.registry).getById(componentId)) === null || _registry_getById === void 0 ? void 0 : _registry_getById.render;
    if (typeof RenderComponent !== "function") return renderFallback();
    return (0, $c9Ozz.jsx)((0, $chcmK.default), {
        renderFallback: renderFallback,
        children: (0, $c9Ozz.jsx)((0, $gDoOy.default).div, {
            children: (0, $c9Ozz.jsx)(RenderComponent, (0, $gu11n._)({
                data: data
            }, additionalProps))
        })
    });
}

});
parcelRegister("gDoOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c389753a00d80d$export$2e2bcd8739ae039; });

var $g85JO = parcelRequire("g85JO");

var $6fLEz = parcelRequire("6fLEz");

var $3WaCF = parcelRequire("3WaCF");

var $bnpdr = parcelRequire("bnpdr");
var $c1c389753a00d80d$var$f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $c1c389753a00d80d$var$p(e, r) {
    return e(r = {
        exports: {}
    }, r.exports), r.exports;
}
var $c1c389753a00d80d$var$d = $c1c389753a00d80d$var$p(function(e) {
    !function(r) {
        var t = function t1(e, r, n) {
            if (!u(r) || _$s(r) || f(r) || _$p(r) || i(r)) return r;
            var o, a = 0, c = 0;
            if (l(r)) for(o = [], c = r.length; a < c; a++)o.push(t(e, r[a], n));
            else for(var d in o = {}, r)Object.prototype.hasOwnProperty.call(r, d) && (o[e(d, n)] = t(e, r[d], n));
            return o;
        }, _$n = function n(e) {
            return d(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(e, r) {
                return r ? r.toUpperCase() : "";
            })).substr(0, 1).toLowerCase() + e.substr(1);
        }, o = function o(e) {
            var _$r = _$n(e);
            return _$r.substr(0, 1).toUpperCase() + _$r.substr(1);
        }, a = function a(e, r) {
            return (function(e, r) {
                var t = (r = r || {}).separator || "_", _$n = r.split || /(?=[A-Z])/;
                return e.split(_$n).join(t);
            })(e, r).toLowerCase();
        }, c = Object.prototype.toString, i = function i(e) {
            return "function" == typeof e;
        }, u = function u(e) {
            return e === Object(e);
        }, l = function l(e) {
            return "[object Array]" == c.call(e);
        }, _$s = function s(e) {
            return "[object Date]" == c.call(e);
        }, f = function f(e) {
            return "[object RegExp]" == c.call(e);
        }, _$p = function p(e) {
            return "[object Boolean]" == c.call(e);
        }, d = function d(e) {
            return (e -= 0) == e;
        }, y = function y(e, r) {
            var t = r && "process" in r ? r.process : r;
            return "function" != typeof t ? e : function(r, n) {
                return t(r, e, n);
            };
        }, h = {
            camelize: _$n,
            decamelize: a,
            pascalize: o,
            depascalize: a,
            camelizeKeys: function camelizeKeys(e, r) {
                return t(y(_$n, r), e);
            },
            decamelizeKeys: function decamelizeKeys(e, r) {
                return t(y(a, r), e, r);
            },
            pascalizeKeys: function pascalizeKeys(e, r) {
                return t(y(o, r), e);
            },
            depascalizeKeys: function depascalizeKeys() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        e.exports ? e.exports = h : r.humps = h;
    }($c1c389753a00d80d$var$f);
}).decamelize;
var $c1c389753a00d80d$var$y = function y(e) {
    if (Array.isArray(e)) return e;
};
var $c1c389753a00d80d$var$h = function h(e, r) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var t = [], _$n = !0, o = !1, a = void 0;
        try {
            for(var c, i = e[Symbol.iterator](); !(_$n = (c = i.next()).done) && (t.push(c.value), !r || t.length !== r); _$n = !0);
        } catch (e) {
            o = !0, a = e;
        } finally{
            try {
                _$n || null == i.return || i.return();
            } finally{
                if (o) throw a;
            }
        }
        return t;
    }
};
var $c1c389753a00d80d$var$v = function v(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, _$n = new Array(r); t < r; t++)_$n[t] = e[t];
    return _$n;
};
var $c1c389753a00d80d$var$m = function m(e, r) {
    if (e) {
        if ("string" == typeof e) return $c1c389753a00d80d$var$v(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c1c389753a00d80d$var$v(e, r) : void 0;
    }
};
var $c1c389753a00d80d$var$b = function b() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var $c1c389753a00d80d$var$g = function g(e, r) {
    return $c1c389753a00d80d$var$y(e) || $c1c389753a00d80d$var$h(e, r) || $c1c389753a00d80d$var$m(e, r) || $c1c389753a00d80d$var$b();
}, $c1c389753a00d80d$var$S = $c1c389753a00d80d$var$p(function(e) {
    function r() {
        return e.exports = r = Object.assign || function(e) {
            for(var _$r = 1; _$r < arguments.length; _$r++){
                var t = arguments[_$r];
                for(var _$n in t)Object.prototype.hasOwnProperty.call(t, _$n) && (e[_$n] = t[_$n]);
            }
            return e;
        }, r.apply(this, arguments);
    }
    e.exports = r;
});
var $c1c389753a00d80d$var$w = function w(e, r) {
    if (null == e) return {};
    var t, _$n, o = {}, a = Object.keys(e);
    for(_$n = 0; _$n < a.length; _$n++)t = a[_$n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
};
var $c1c389753a00d80d$var$O = function O(e, r) {
    if (null == e) return {};
    var t, _$n, o = $c1c389753a00d80d$var$w(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(_$n = 0; _$n < a.length; _$n++)t = a[_$n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
};
var $c1c389753a00d80d$var$j = (0, $g85JO.createContext)(null);
function $c1c389753a00d80d$var$x(r) {
    var t = r.children, _$n = void 0 === t ? "" : t, o = $c1c389753a00d80d$var$O(r, [
        "children"
    ]);
    return "string" != typeof _$n && (_$n = (0, $3WaCF.renderToString)(_$n)), (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("template", $c1c389753a00d80d$var$S({}, o, {
        dangerouslySetInnerHTML: {
            __html: _$n
        }
    }));
}
function $c1c389753a00d80d$var$z(e) {
    var r = e.root, t = e.children;
    return (0, $6fLEz.createPortal)(void 0 === t ? null : t, r);
}
function $c1c389753a00d80d$var$E(n) {
    var i = (0, $g85JO.forwardRef)(function(o, i) {
        var u, l, _$s = o.mode, f = void 0 === _$s ? "open" : _$s, _$p = o.delegatesFocus, d = void 0 !== _$p && _$p, y = o.styleSheets, h = void 0 === y ? [] : y, v = o.ssr, m = void 0 !== v && v, b = o.children, w = $c1c389753a00d80d$var$O(o, [
            "mode",
            "delegatesFocus",
            "styleSheets",
            "ssr",
            "children"
        ]), E = (l = (0, $g85JO.useRef)((u = i) && u.current), (0, $g85JO.useEffect)(function() {
            u && (u.current = l.current);
        }, [
            u
        ]), l), T = (0, $g85JO.useState)(null), A = $c1c389753a00d80d$var$g(T, 2), _$C = A[0], P = A[1], F = "node_".concat(f).concat(d);
        return (0, $g85JO.useLayoutEffect)(function() {
            if (E.current) try {
                if ("function" == typeof i && i(E.current), m) {
                    var _$e = E.current.shadowRoot;
                    return void P(_$e);
                }
                var _$r = E.current.attachShadow({
                    mode: f,
                    delegatesFocus: d
                });
                h.length > 0 && (_$r.adoptedStyleSheets = h), P(_$r);
            } catch (e) {
                !function(e) {
                    var _$r = e.error, _$t = e.styleSheets, _$n = e.root;
                    switch(_$r.name){
                        case "NotSupportedError":
                            _$t.length > 0 && (_$n.adoptedStyleSheets = _$t);
                            break;
                        default:
                            throw _$r;
                    }
                }({
                    error: e,
                    styleSheets: h,
                    root: _$C
                });
            }
        }, [
            i,
            E,
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement(n.tag, $c1c389753a00d80d$var$S({
            key: F,
            ref: E
        }, w), (_$C || m) && (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement($c1c389753a00d80d$var$j.Provider, {
            value: _$C
        }, m ? (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement($c1c389753a00d80d$var$x, {
            shadowroot: f,
            shadowrootmode: f
        }, n.render({
            root: _$C,
            ssr: m,
            children: b
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement($c1c389753a00d80d$var$z, {
            root: _$C
        }, n.render({
            root: _$C,
            ssr: m,
            children: b
        })))));
    });
    return i.propTypes = {
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).oneOf([
            "open",
            "closed"
        ]),
        delegatesFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).bool,
        styleSheets: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).instanceOf(globalThis.CSSStyleSheet)),
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).bool,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).node
    }, i;
}
$c1c389753a00d80d$var$x.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).node
    ])
}, $c1c389753a00d80d$var$z.propTypes = {
    root: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bnpdr))).node
};
var $c1c389753a00d80d$var$T = new Map;
function $c1c389753a00d80d$export$64d45095031fa749() {
    return (0, $g85JO.useContext)($c1c389753a00d80d$var$j);
}
function $c1c389753a00d80d$export$7865d0c7f908de6b() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core", t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function t(e) {
        return e.children;
    };
    return new Proxy(e, {
        get: function get(e, n) {
            var o = $c1c389753a00d80d$var$d(n, {
                separator: "-"
            }), a = "".concat(r, "-").concat(o);
            return $c1c389753a00d80d$var$T.has(a) || $c1c389753a00d80d$var$T.set(a, $c1c389753a00d80d$var$E({
                tag: o,
                render: t
            })), $c1c389753a00d80d$var$T.get(a);
        }
    });
}
var $c1c389753a00d80d$var$P = $c1c389753a00d80d$export$7865d0c7f908de6b();
var $c1c389753a00d80d$export$2e2bcd8739ae039 = $c1c389753a00d80d$var$P;

});
parcelRegister("3WaCF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("d1oYk"));

});
parcelRegister("d1oYk", function(module, exports) {
/** @license React v16.14.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gfRPo = parcelRequire("gfRPo");
"use strict";

var $22Kv0 = parcelRequire("22Kv0");

var $g85JO = parcelRequire("g85JO");
function $97aebd4d8305cd45$var$q(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $97aebd4d8305cd45$var$t = "function" === typeof Symbol && Symbol.for, $97aebd4d8305cd45$var$aa = $97aebd4d8305cd45$var$t ? Symbol.for("react.portal") : 60106, $97aebd4d8305cd45$var$u = $97aebd4d8305cd45$var$t ? Symbol.for("react.fragment") : 60107, $97aebd4d8305cd45$var$ba = $97aebd4d8305cd45$var$t ? Symbol.for("react.strict_mode") : 60108, $97aebd4d8305cd45$var$ca = $97aebd4d8305cd45$var$t ? Symbol.for("react.profiler") : 60114, $97aebd4d8305cd45$var$v = $97aebd4d8305cd45$var$t ? Symbol.for("react.provider") : 60109, $97aebd4d8305cd45$var$da = $97aebd4d8305cd45$var$t ? Symbol.for("react.context") : 60110, $97aebd4d8305cd45$var$ea = $97aebd4d8305cd45$var$t ? Symbol.for("react.concurrent_mode") : 60111, $97aebd4d8305cd45$var$fa = $97aebd4d8305cd45$var$t ? Symbol.for("react.forward_ref") : 60112, $97aebd4d8305cd45$var$B = $97aebd4d8305cd45$var$t ? Symbol.for("react.suspense") : 60113, $97aebd4d8305cd45$var$ha = $97aebd4d8305cd45$var$t ? Symbol.for("react.suspense_list") : 60120, $97aebd4d8305cd45$var$ia = $97aebd4d8305cd45$var$t ? Symbol.for("react.memo") : 60115, $97aebd4d8305cd45$var$ja = $97aebd4d8305cd45$var$t ? Symbol.for("react.lazy") : 60116, $97aebd4d8305cd45$var$ka = $97aebd4d8305cd45$var$t ? Symbol.for("react.block") : 60121, $97aebd4d8305cd45$var$la = $97aebd4d8305cd45$var$t ? Symbol.for("react.fundamental") : 60117, $97aebd4d8305cd45$var$ma = $97aebd4d8305cd45$var$t ? Symbol.for("react.scope") : 60119;
function $97aebd4d8305cd45$var$na(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(c) {
            0 === a._status && (c = c.default, a._status = 1, a._result = c);
        }, function(c) {
            0 === a._status && (a._status = 2, a._result = c);
        });
    }
}
function $97aebd4d8305cd45$var$C(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $97aebd4d8305cd45$var$u:
            return "Fragment";
        case $97aebd4d8305cd45$var$aa:
            return "Portal";
        case $97aebd4d8305cd45$var$ca:
            return "Profiler";
        case $97aebd4d8305cd45$var$ba:
            return "StrictMode";
        case $97aebd4d8305cd45$var$B:
            return "Suspense";
        case $97aebd4d8305cd45$var$ha:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $97aebd4d8305cd45$var$da:
            return "Context.Consumer";
        case $97aebd4d8305cd45$var$v:
            return "Context.Provider";
        case $97aebd4d8305cd45$var$fa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $97aebd4d8305cd45$var$ia:
            return $97aebd4d8305cd45$var$C(a.type);
        case $97aebd4d8305cd45$var$ka:
            return $97aebd4d8305cd45$var$C(a.render);
        case $97aebd4d8305cd45$var$ja:
            if (a = 1 === a._status ? a._result : null) return $97aebd4d8305cd45$var$C(a);
    }
    return null;
}
var $97aebd4d8305cd45$var$D = $g85JO.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$97aebd4d8305cd45$var$D.hasOwnProperty("ReactCurrentDispatcher") || ($97aebd4d8305cd45$var$D.ReactCurrentDispatcher = {
    current: null
});
$97aebd4d8305cd45$var$D.hasOwnProperty("ReactCurrentBatchConfig") || ($97aebd4d8305cd45$var$D.ReactCurrentBatchConfig = {
    suspense: null
});
var $97aebd4d8305cd45$var$oa = {};
function $97aebd4d8305cd45$var$E(a, b) {
    for(var c = a._threadCount | 0; c <= b; c++)a[c] = a._currentValue2, a._threadCount = c + 1;
}
function $97aebd4d8305cd45$var$pa(a, b, c, d) {
    if (d && (d = a.contextType, "object" === typeof d && null !== d)) return $97aebd4d8305cd45$var$E(d, c), d[c];
    if (a = a.contextTypes) {
        c = {};
        for(var f in a)c[f] = b[f];
        b = c;
    } else b = $97aebd4d8305cd45$var$oa;
    return b;
}
for(var $97aebd4d8305cd45$var$F = new Uint16Array(16), $97aebd4d8305cd45$var$H = 0; 15 > $97aebd4d8305cd45$var$H; $97aebd4d8305cd45$var$H++)$97aebd4d8305cd45$var$F[$97aebd4d8305cd45$var$H] = $97aebd4d8305cd45$var$H + 1;
$97aebd4d8305cd45$var$F[15] = 0;
var $97aebd4d8305cd45$var$qa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $97aebd4d8305cd45$var$ra = Object.prototype.hasOwnProperty, $97aebd4d8305cd45$var$sa = {}, $97aebd4d8305cd45$var$ta = {};
function $97aebd4d8305cd45$var$ua(a) {
    if ($97aebd4d8305cd45$var$ra.call($97aebd4d8305cd45$var$ta, a)) return !0;
    if ($97aebd4d8305cd45$var$ra.call($97aebd4d8305cd45$var$sa, a)) return !1;
    if ($97aebd4d8305cd45$var$qa.test(a)) return $97aebd4d8305cd45$var$ta[a] = !0;
    $97aebd4d8305cd45$var$sa[a] = !0;
    return !1;
}
function $97aebd4d8305cd45$var$va(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $gfRPo._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $97aebd4d8305cd45$var$wa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $97aebd4d8305cd45$var$va(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $97aebd4d8305cd45$var$J(a, b, c, d, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = g;
}
var $97aebd4d8305cd45$var$K = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $97aebd4d8305cd45$var$K[b] = new $97aebd4d8305cd45$var$J(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 5, !1, a.toLowerCase(), null, !1);
});
var $97aebd4d8305cd45$var$L = /[\-:]([a-z])/g;
function $97aebd4d8305cd45$var$M(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($97aebd4d8305cd45$var$L, $97aebd4d8305cd45$var$M);
    $97aebd4d8305cd45$var$K[b] = new $97aebd4d8305cd45$var$J(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($97aebd4d8305cd45$var$L, $97aebd4d8305cd45$var$M);
    $97aebd4d8305cd45$var$K[b] = new $97aebd4d8305cd45$var$J(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($97aebd4d8305cd45$var$L, $97aebd4d8305cd45$var$M);
    $97aebd4d8305cd45$var$K[b] = new $97aebd4d8305cd45$var$J(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 1, !1, a.toLowerCase(), null, !1);
});
$97aebd4d8305cd45$var$K.xlinkHref = new $97aebd4d8305cd45$var$J("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $97aebd4d8305cd45$var$K[a] = new $97aebd4d8305cd45$var$J(a, 1, !1, a.toLowerCase(), null, !0);
});
var $97aebd4d8305cd45$var$xa = /["'&<>]/;
function $97aebd4d8305cd45$var$N(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $97aebd4d8305cd45$var$xa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
function $97aebd4d8305cd45$var$ya(a, b) {
    var c = $97aebd4d8305cd45$var$K.hasOwnProperty(a) ? $97aebd4d8305cd45$var$K[a] : null;
    var d;
    if (d = "style" !== a) d = null !== c ? 0 === c.type : !(2 < a.length) || "o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1] ? !1 : !0;
    if (d || $97aebd4d8305cd45$var$wa(a, b, c, !1)) return "";
    if (null !== c) {
        a = c.attributeName;
        d = c.type;
        if (3 === d || 4 === d && !0 === b) return a + '=""';
        c.sanitizeURL && (b = "" + b);
        return a + '="' + ($97aebd4d8305cd45$var$N(b) + '"');
    }
    return $97aebd4d8305cd45$var$ua(a) ? a + '="' + ($97aebd4d8305cd45$var$N(b) + '"') : "";
}
function $97aebd4d8305cd45$var$za(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $97aebd4d8305cd45$var$Aa = "function" === typeof Object.is ? Object.is : $97aebd4d8305cd45$var$za, $97aebd4d8305cd45$var$O = null, $97aebd4d8305cd45$var$P = null, $97aebd4d8305cd45$var$Q = null, $97aebd4d8305cd45$var$R = !1, $97aebd4d8305cd45$var$S = !1, $97aebd4d8305cd45$var$U = null, $97aebd4d8305cd45$var$V = 0;
function $97aebd4d8305cd45$var$W() {
    if (null === $97aebd4d8305cd45$var$O) throw Error($97aebd4d8305cd45$var$q(321));
    return $97aebd4d8305cd45$var$O;
}
function $97aebd4d8305cd45$var$Ba() {
    if (0 < $97aebd4d8305cd45$var$V) throw Error($97aebd4d8305cd45$var$q(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $97aebd4d8305cd45$var$Ca() {
    null === $97aebd4d8305cd45$var$Q ? null === $97aebd4d8305cd45$var$P ? ($97aebd4d8305cd45$var$R = !1, $97aebd4d8305cd45$var$P = $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$Ba()) : ($97aebd4d8305cd45$var$R = !0, $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$P) : null === $97aebd4d8305cd45$var$Q.next ? ($97aebd4d8305cd45$var$R = !1, $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$Q.next = $97aebd4d8305cd45$var$Ba()) : ($97aebd4d8305cd45$var$R = !0, $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$Q.next);
    return $97aebd4d8305cd45$var$Q;
}
function $97aebd4d8305cd45$var$Da(a, b, c, d) {
    for(; $97aebd4d8305cd45$var$S;)$97aebd4d8305cd45$var$S = !1, $97aebd4d8305cd45$var$V += 1, $97aebd4d8305cd45$var$Q = null, c = a(b, d);
    $97aebd4d8305cd45$var$P = $97aebd4d8305cd45$var$O = null;
    $97aebd4d8305cd45$var$V = 0;
    $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$U = null;
    return c;
}
function $97aebd4d8305cd45$var$Ea(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $97aebd4d8305cd45$var$Fa(a, b, c) {
    $97aebd4d8305cd45$var$O = $97aebd4d8305cd45$var$W();
    $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$Ca();
    if ($97aebd4d8305cd45$var$R) {
        var d = $97aebd4d8305cd45$var$Q.queue;
        b = d.dispatch;
        if (null !== $97aebd4d8305cd45$var$U && (c = $97aebd4d8305cd45$var$U.get(d), void 0 !== c)) {
            $97aebd4d8305cd45$var$U.delete(d);
            d = $97aebd4d8305cd45$var$Q.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $97aebd4d8305cd45$var$Q.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $97aebd4d8305cd45$var$Q.memoizedState,
            b
        ];
    }
    a = a === $97aebd4d8305cd45$var$Ea ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $97aebd4d8305cd45$var$Q.memoizedState = a;
    a = $97aebd4d8305cd45$var$Q.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $97aebd4d8305cd45$var$Ga.bind(null, $97aebd4d8305cd45$var$O, a);
    return [
        $97aebd4d8305cd45$var$Q.memoizedState,
        a
    ];
}
function $97aebd4d8305cd45$var$Ga(a, b, c) {
    if (!(25 > $97aebd4d8305cd45$var$V)) throw Error($97aebd4d8305cd45$var$q(301));
    if (a === $97aebd4d8305cd45$var$O) {
        if ($97aebd4d8305cd45$var$S = !0, a = {
            action: c,
            next: null
        }, null === $97aebd4d8305cd45$var$U && ($97aebd4d8305cd45$var$U = new Map), c = $97aebd4d8305cd45$var$U.get(b), void 0 === c) $97aebd4d8305cd45$var$U.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $97aebd4d8305cd45$var$Ha() {}
var $97aebd4d8305cd45$var$X = 0, $97aebd4d8305cd45$var$Ia = {
    readContext: function readContext(a) {
        var b = $97aebd4d8305cd45$var$X;
        $97aebd4d8305cd45$var$E(a, b);
        return a[b];
    },
    useContext: function useContext(a) {
        $97aebd4d8305cd45$var$W();
        var b = $97aebd4d8305cd45$var$X;
        $97aebd4d8305cd45$var$E(a, b);
        return a[b];
    },
    useMemo: function useMemo(a, b) {
        $97aebd4d8305cd45$var$O = $97aebd4d8305cd45$var$W();
        $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$Ca();
        b = void 0 === b ? null : b;
        if (null !== $97aebd4d8305cd45$var$Q) {
            var c = $97aebd4d8305cd45$var$Q.memoizedState;
            if (null !== c && null !== b) {
                a: {
                    var d = c[1];
                    if (null === d) d = !1;
                    else {
                        for(var f = 0; f < d.length && f < b.length; f++)if (!$97aebd4d8305cd45$var$Aa(b[f], d[f])) {
                            d = !1;
                            break a;
                        }
                        d = !0;
                    }
                }
                if (d) return c[0];
            }
        }
        a = a();
        $97aebd4d8305cd45$var$Q.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $97aebd4d8305cd45$var$Fa,
    useRef: function useRef(a) {
        $97aebd4d8305cd45$var$O = $97aebd4d8305cd45$var$W();
        $97aebd4d8305cd45$var$Q = $97aebd4d8305cd45$var$Ca();
        var b = $97aebd4d8305cd45$var$Q.memoizedState;
        return null === b ? (a = {
            current: a
        }, $97aebd4d8305cd45$var$Q.memoizedState = a) : b;
    },
    useState: function useState(a) {
        return $97aebd4d8305cd45$var$Fa($97aebd4d8305cd45$var$Ea, a);
    },
    useLayoutEffect: function useLayoutEffect() {},
    useCallback: function useCallback(a) {
        return a;
    },
    useImperativeHandle: $97aebd4d8305cd45$var$Ha,
    useEffect: $97aebd4d8305cd45$var$Ha,
    useDebugValue: $97aebd4d8305cd45$var$Ha,
    useResponder: function useResponder(a, b) {
        return {
            props: b,
            responder: a
        };
    },
    useDeferredValue: function useDeferredValue(a) {
        $97aebd4d8305cd45$var$W();
        return a;
    },
    useTransition: function useTransition() {
        $97aebd4d8305cd45$var$W();
        return [
            function(a) {
                a();
            },
            !1
        ];
    }
}, $97aebd4d8305cd45$var$Ja = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $97aebd4d8305cd45$var$Ka(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var $97aebd4d8305cd45$var$La = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, $97aebd4d8305cd45$var$Ma = $22Kv0({
    menuitem: !0
}, $97aebd4d8305cd45$var$La), $97aebd4d8305cd45$var$Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $97aebd4d8305cd45$var$Na = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($97aebd4d8305cd45$var$Y).forEach(function(a) {
    $97aebd4d8305cd45$var$Na.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $97aebd4d8305cd45$var$Y[b] = $97aebd4d8305cd45$var$Y[a];
    });
});
var $97aebd4d8305cd45$var$Oa = /([A-Z])/g, $97aebd4d8305cd45$var$Pa = /^ms-/, $97aebd4d8305cd45$var$Z = $g85JO.Children.toArray, $97aebd4d8305cd45$var$Qa = $97aebd4d8305cd45$var$D.ReactCurrentDispatcher, $97aebd4d8305cd45$var$Ra = {
    listing: !0,
    pre: !0,
    textarea: !0
}, $97aebd4d8305cd45$var$Sa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $97aebd4d8305cd45$var$Ta = {}, $97aebd4d8305cd45$var$Ua = {};
function $97aebd4d8305cd45$var$Va(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    $g85JO.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $97aebd4d8305cd45$var$Wa = Object.prototype.hasOwnProperty, $97aebd4d8305cd45$var$Xa = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $97aebd4d8305cd45$var$Ya(a, b) {
    if (void 0 === a) throw Error($97aebd4d8305cd45$var$q(152, $97aebd4d8305cd45$var$C(b) || "Component"));
}
function $97aebd4d8305cd45$var$Za(a, b, c) {
    function d(d, g) {
        var e = g.prototype && g.prototype.isReactComponent, f = $97aebd4d8305cd45$var$pa(g, b, c, e), x = [], h = !1, m = {
            isMounted: function isMounted() {
                return !1;
            },
            enqueueForceUpdate: function enqueueForceUpdate() {
                if (null === x) return null;
            },
            enqueueReplaceState: function enqueueReplaceState(a, c) {
                h = !0;
                x = [
                    c
                ];
            },
            enqueueSetState: function enqueueSetState(a, c) {
                if (null === x) return null;
                x.push(c);
            }
        };
        if (e) {
            if (e = new g(d.props, f, m), "function" === typeof g.getDerivedStateFromProps) {
                var w = g.getDerivedStateFromProps.call(null, d.props, e.state);
                null != w && (e.state = $22Kv0({}, e.state, w));
            }
        } else if ($97aebd4d8305cd45$var$O = {}, e = g(d.props, f, m), e = $97aebd4d8305cd45$var$Da(g, d.props, e, f), null == e || null == e.render) {
            a = e;
            $97aebd4d8305cd45$var$Ya(a, g);
            return;
        }
        e.props = d.props;
        e.context = f;
        e.updater = m;
        m = e.state;
        void 0 === m && (e.state = m = null);
        if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) {
            if ("function" === typeof e.componentWillMount && "function" !== typeof g.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof g.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), x.length) {
                m = x;
                var r = h;
                x = null;
                h = !1;
                if (r && 1 === m.length) e.state = m[0];
                else {
                    w = r ? m[0] : e.state;
                    var y = !0;
                    for(r = r ? 1 : 0; r < m.length; r++){
                        var p = m[r];
                        p = "function" === typeof p ? p.call(e, w, d.props, f) : p;
                        null != p && (y ? (y = !1, w = $22Kv0({}, w, p)) : $22Kv0(w, p));
                    }
                    e.state = w;
                }
            } else x = null;
        }
        a = e.render();
        $97aebd4d8305cd45$var$Ya(a, g);
        if ("function" === typeof e.getChildContext && (d = g.childContextTypes, "object" === typeof d)) {
            var A = e.getChildContext();
            for(var T in A)if (!(T in d)) throw Error($97aebd4d8305cd45$var$q(108, $97aebd4d8305cd45$var$C(g) || "Unknown", T));
        }
        A && (b = $22Kv0({}, b, A));
    }
    for(; $g85JO.isValidElement(a);){
        var f = a, g = f.type;
        if ("function" !== typeof g) break;
        d(f, g);
    }
    return {
        child: a,
        context: b
    };
}
var $97aebd4d8305cd45$var$$a = function() {
    function a(a, b) {
        $g85JO.isValidElement(a) ? a.type !== $97aebd4d8305cd45$var$u ? a = [
            a
        ] : (a = a.props.children, a = $g85JO.isValidElement(a) ? [
            a
        ] : $97aebd4d8305cd45$var$Z(a)) : a = $97aebd4d8305cd45$var$Z(a);
        a = {
            type: null,
            domNamespace: $97aebd4d8305cd45$var$Ja.html,
            children: a,
            childIndex: 0,
            context: $97aebd4d8305cd45$var$oa,
            footer: ""
        };
        var c = $97aebd4d8305cd45$var$F[0];
        if (0 === c) {
            var g = $97aebd4d8305cd45$var$F;
            c = g.length;
            var d = 2 * c;
            if (!(65536 >= d)) throw Error($97aebd4d8305cd45$var$q(304));
            var h = new Uint16Array(d);
            h.set(g);
            $97aebd4d8305cd45$var$F = h;
            $97aebd4d8305cd45$var$F[0] = c + 1;
            for(g = c; g < d - 1; g++)$97aebd4d8305cd45$var$F[g] = g + 1;
            $97aebd4d8305cd45$var$F[d - 1] = 0;
        } else $97aebd4d8305cd45$var$F[0] = $97aebd4d8305cd45$var$F[c];
        this.threadID = c;
        this.stack = [
            a
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = b;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
    }
    var b = a.prototype;
    b.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var _$a = this.threadID;
            $97aebd4d8305cd45$var$F[_$a] = $97aebd4d8305cd45$var$F[0];
            $97aebd4d8305cd45$var$F[0] = _$a;
        }
    };
    b.pushProvider = function(a) {
        var c = ++this.contextIndex, b = a.type._context, g = this.threadID;
        $97aebd4d8305cd45$var$E(b, g);
        var x = b[g];
        this.contextStack[c] = b;
        this.contextValueStack[c] = x;
        b[g] = a.props.value;
    };
    b.popProvider = function() {
        var _$a = this.contextIndex, b = this.contextStack[_$a], f = this.contextValueStack[_$a];
        this.contextStack[_$a] = null;
        this.contextValueStack[_$a] = null;
        this.contextIndex--;
        b[this.threadID] = f;
    };
    b.clearProviders = function() {
        for(var _$a = this.contextIndex; 0 <= _$a; _$a--)this.contextStack[_$a][this.threadID] = this.contextValueStack[_$a];
    };
    b.read = function(a) {
        if (this.exhausted) return null;
        var b = $97aebd4d8305cd45$var$X;
        $97aebd4d8305cd45$var$X = this.threadID;
        var c = $97aebd4d8305cd45$var$Qa.current;
        $97aebd4d8305cd45$var$Qa.current = $97aebd4d8305cd45$var$Ia;
        try {
            for(var g = [
                ""
            ], x = !1; g[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var h = this.threadID;
                    $97aebd4d8305cd45$var$F[h] = $97aebd4d8305cd45$var$F[0];
                    $97aebd4d8305cd45$var$F[0] = h;
                    break;
                }
                var e = this.stack[this.stack.length - 1];
                if (x || e.childIndex >= e.children.length) {
                    var I = e.footer;
                    "" !== I && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === e.type) this.currentSelectValue = null;
                    else if (null != e.type && null != e.type.type && e.type.type.$$typeof === $97aebd4d8305cd45$var$v) this.popProvider(e.type);
                    else if (e.type === $97aebd4d8305cd45$var$B) {
                        this.suspenseDepth--;
                        var G = g.pop();
                        if (x) {
                            x = !1;
                            var n = e.fallbackFrame;
                            if (!n) throw Error($97aebd4d8305cd45$var$q(303));
                            this.stack.push(n);
                            g[this.suspenseDepth] += "<!--$!-->";
                            continue;
                        } else g[this.suspenseDepth] += G;
                    }
                    g[this.suspenseDepth] += I;
                } else {
                    var m = e.children[e.childIndex++], w = "";
                    try {
                        w += this.render(m, e.context, e.domNamespace);
                    } catch (r) {
                        if (null != r && "function" === typeof r.then) throw Error($97aebd4d8305cd45$var$q(294));
                        throw r;
                    } finally{}
                    g.length <= this.suspenseDepth && g.push("");
                    g[this.suspenseDepth] += w;
                }
            }
            return g[0];
        } finally{
            $97aebd4d8305cd45$var$Qa.current = c, $97aebd4d8305cd45$var$X = b;
        }
    };
    b.render = function(a, b, f) {
        if ("string" === typeof a || "number" === typeof a) {
            f = "" + a;
            if ("" === f) return "";
            if (this.makeStaticMarkup) return $97aebd4d8305cd45$var$N(f);
            if (this.previousWasTextNode) return "<!-- -->" + $97aebd4d8305cd45$var$N(f);
            this.previousWasTextNode = !0;
            return $97aebd4d8305cd45$var$N(f);
        }
        b = $97aebd4d8305cd45$var$Za(a, b, this.threadID);
        a = b.child;
        b = b.context;
        if (null === a || !1 === a) return "";
        if (!$g85JO.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                f = a.$$typeof;
                if (f === $97aebd4d8305cd45$var$aa) throw Error($97aebd4d8305cd45$var$q(257));
                throw Error($97aebd4d8305cd45$var$q(258, f.toString()));
            }
            a = $97aebd4d8305cd45$var$Z(a);
            this.stack.push({
                type: null,
                domNamespace: f,
                children: a,
                childIndex: 0,
                context: b,
                footer: ""
            });
            return "";
        }
        var c = a.type;
        if ("string" === typeof c) return this.renderDOM(a, b, f);
        switch(c){
            case $97aebd4d8305cd45$var$ba:
            case $97aebd4d8305cd45$var$ea:
            case $97aebd4d8305cd45$var$ca:
            case $97aebd4d8305cd45$var$ha:
            case $97aebd4d8305cd45$var$u:
                return a = $97aebd4d8305cd45$var$Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $97aebd4d8305cd45$var$B:
                throw Error($97aebd4d8305cd45$var$q(294));
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $97aebd4d8305cd45$var$fa:
                $97aebd4d8305cd45$var$O = {};
                var d = c.render(a.props, a.ref);
                d = $97aebd4d8305cd45$var$Da(c.render, a.props, d, a.ref);
                d = $97aebd4d8305cd45$var$Z(d);
                this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: d,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $97aebd4d8305cd45$var$ia:
                return a = [
                    $g85JO.createElement(c.type, $22Kv0({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $97aebd4d8305cd45$var$v:
                return c = $97aebd4d8305cd45$var$Z(a.props.children), f = {
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(f), "";
            case $97aebd4d8305cd45$var$da:
                c = a.type;
                d = a.props;
                var h = this.threadID;
                $97aebd4d8305cd45$var$E(c, h);
                c = $97aebd4d8305cd45$var$Z(d.children(c[h]));
                this.stack.push({
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $97aebd4d8305cd45$var$la:
                throw Error($97aebd4d8305cd45$var$q(338));
            case $97aebd4d8305cd45$var$ja:
                switch(c = a.type, $97aebd4d8305cd45$var$na(c), c._status){
                    case 1:
                        return a = [
                            $g85JO.createElement(c._result, $22Kv0({
                                ref: a.ref
                            }, a.props))
                        ], this.stack.push({
                            type: null,
                            domNamespace: f,
                            children: a,
                            childIndex: 0,
                            context: b,
                            footer: ""
                        }), "";
                    case 2:
                        throw c._result;
                    default:
                        throw Error($97aebd4d8305cd45$var$q(295));
                }
            case $97aebd4d8305cd45$var$ma:
                throw Error($97aebd4d8305cd45$var$q(343));
        }
        throw Error($97aebd4d8305cd45$var$q(130, null == c ? c : typeof c === "undefined" ? "undefined" : (0, $gfRPo._)(c), ""));
    };
    b.renderDOM = function(a, b, f) {
        var c = a.type.toLowerCase();
        f === $97aebd4d8305cd45$var$Ja.html && $97aebd4d8305cd45$var$Ka(c);
        if (!$97aebd4d8305cd45$var$Ta.hasOwnProperty(c)) {
            if (!$97aebd4d8305cd45$var$Sa.test(c)) throw Error($97aebd4d8305cd45$var$q(65, c));
            $97aebd4d8305cd45$var$Ta[c] = !0;
        }
        var d = a.props;
        if ("input" === c) d = $22Kv0({
            type: void 0
        }, d, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != d.value ? d.value : d.defaultValue,
            checked: null != d.checked ? d.checked : d.defaultChecked
        });
        else if ("textarea" === c) {
            var h = d.value;
            if (null == h) {
                h = d.defaultValue;
                var e = d.children;
                if (null != e) {
                    if (null != h) throw Error($97aebd4d8305cd45$var$q(92));
                    if (Array.isArray(e)) {
                        if (!(1 >= e.length)) throw Error($97aebd4d8305cd45$var$q(93));
                        e = e[0];
                    }
                    h = "" + e;
                }
                null == h && (h = "");
            }
            d = $22Kv0({}, d, {
                value: void 0,
                children: "" + h
            });
        } else if ("select" === c) this.currentSelectValue = null != d.value ? d.value : d.defaultValue, d = $22Kv0({}, d, {
            value: void 0
        });
        else if ("option" === c) {
            e = this.currentSelectValue;
            var I = $97aebd4d8305cd45$var$Va(d.children);
            if (null != e) {
                var G = null != d.value ? d.value + "" : I;
                h = !1;
                if (Array.isArray(e)) {
                    for(var n = 0; n < e.length; n++)if ("" + e[n] === G) {
                        h = !0;
                        break;
                    }
                } else h = "" + e === G;
                d = $22Kv0({
                    selected: void 0,
                    children: void 0
                }, d, {
                    selected: h,
                    children: I
                });
            }
        }
        if (h = d) {
            if ($97aebd4d8305cd45$var$Ma[c] && (null != h.children || null != h.dangerouslySetInnerHTML)) throw Error($97aebd4d8305cd45$var$q(137, c, ""));
            if (null != h.dangerouslySetInnerHTML) {
                if (null != h.children) throw Error($97aebd4d8305cd45$var$q(60));
                if (!("object" === typeof h.dangerouslySetInnerHTML && "__html" in h.dangerouslySetInnerHTML)) throw Error($97aebd4d8305cd45$var$q(61));
            }
            if (null != h.style && "object" !== typeof h.style) throw Error($97aebd4d8305cd45$var$q(62, ""));
        }
        h = d;
        e = this.makeStaticMarkup;
        I = 1 === this.stack.length;
        G = "<" + a.type;
        for(z in h)if ($97aebd4d8305cd45$var$Wa.call(h, z)) {
            var m = h[z];
            if (null != m) {
                if ("style" === z) {
                    n = void 0;
                    var w = "", r = "";
                    for(n in m)if (m.hasOwnProperty(n)) {
                        var y = 0 === n.indexOf("--"), p = m[n];
                        if (null != p) {
                            if (y) var A = n;
                            else if (A = n, $97aebd4d8305cd45$var$Ua.hasOwnProperty(A)) A = $97aebd4d8305cd45$var$Ua[A];
                            else {
                                var T = A.replace($97aebd4d8305cd45$var$Oa, "-$1").toLowerCase().replace($97aebd4d8305cd45$var$Pa, "-ms-");
                                A = $97aebd4d8305cd45$var$Ua[A] = T;
                            }
                            w += r + A + ":";
                            r = n;
                            y = null == p || "boolean" === typeof p || "" === p ? "" : y || "number" !== typeof p || 0 === p || $97aebd4d8305cd45$var$Y.hasOwnProperty(r) && $97aebd4d8305cd45$var$Y[r] ? ("" + p).trim() : p + "px";
                            w += y;
                            r = ";";
                        }
                    }
                    m = w || null;
                }
                n = null;
                b: if (y = c, p = h, -1 === y.indexOf("-")) y = "string" === typeof p.is;
                else switch(y){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        y = !1;
                        break b;
                    default:
                        y = !0;
                }
                y ? $97aebd4d8305cd45$var$Xa.hasOwnProperty(z) || (n = z, n = $97aebd4d8305cd45$var$ua(n) && null != m ? n + '="' + ($97aebd4d8305cd45$var$N(m) + '"') : "") : n = $97aebd4d8305cd45$var$ya(z, m);
                n && (G += " " + n);
            }
        }
        e || I && (G += ' data-reactroot=""');
        var z = G;
        h = "";
        $97aebd4d8305cd45$var$La.hasOwnProperty(c) ? z += "/>" : (z += ">", h = "</" + a.type + ">");
        a: {
            e = d.dangerouslySetInnerHTML;
            if (null != e) {
                if (null != e.__html) {
                    e = e.__html;
                    break a;
                }
            } else if (e = d.children, "string" === typeof e || "number" === typeof e) {
                e = $97aebd4d8305cd45$var$N(e);
                break a;
            }
            e = null;
        }
        null != e ? (d = [], $97aebd4d8305cd45$var$Ra.hasOwnProperty(c) && "\n" === e.charAt(0) && (z += "\n"), z += e) : d = $97aebd4d8305cd45$var$Z(d.children);
        a = a.type;
        f = null == f || "http://www.w3.org/1999/xhtml" === f ? $97aebd4d8305cd45$var$Ka(a) : "http://www.w3.org/2000/svg" === f && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : f;
        this.stack.push({
            domNamespace: f,
            type: c,
            children: d,
            childIndex: 0,
            context: b,
            footer: h
        });
        this.previousWasTextNode = !1;
        return z;
    };
    return a;
}(), $97aebd4d8305cd45$var$ab = {
    renderToString: function renderToString(a) {
        a = new $97aebd4d8305cd45$var$$a(a, !1);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToStaticMarkup: function renderToStaticMarkup(a) {
        a = new $97aebd4d8305cd45$var$$a(a, !0);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToNodeStream: function renderToNodeStream() {
        throw Error($97aebd4d8305cd45$var$q(207));
    },
    renderToStaticNodeStream: function renderToStaticNodeStream() {
        throw Error($97aebd4d8305cd45$var$q(208));
    },
    version: "16.14.0"
};
module.exports = $97aebd4d8305cd45$var$ab.default || $97aebd4d8305cd45$var$ab;

});



parcelRegister("chcmK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f00aa3342fdabeb$export$2e2bcd8739ae039; });

var $hCOng = parcelRequire("hCOng");

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $hPrj9 = parcelRequire("hPrj9");

var $3GntQ = parcelRequire("3GntQ");

var $9fsm9 = parcelRequire("9fsm9");
var $8f00aa3342fdabeb$var$ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $hPrj9._)(ErrorBoundary, _React_Component);
    var _super = (0, $3GntQ._)(ErrorBoundary);
    function ErrorBoundary() {
        (0, $6Tsgf._)(this, ErrorBoundary);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        Object.defineProperty((0, $hCOng._)(_this), "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                hasError: false
            }
        });
        return _this;
    }
    (0, $hmsbi._)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("Error caught in ErrorBoundary:", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return this.props.renderFallback();
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(_) {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, $9fsm9.default).Component);
var $8f00aa3342fdabeb$export$2e2bcd8739ae039 = $8f00aa3342fdabeb$var$ErrorBoundary;

});


parcelRegister("6Bg4D", function(module, exports) {

$parcel$export(module.exports, "ComponentLoader", function () { return $4ce2aab2832eb63c$export$5aa84b5b6914a77e; });

var $9fsm9 = parcelRequire("9fsm9");

var $a22BD = parcelRequire("a22BD");

var $jUZe6 = parcelRequire("jUZe6");
function $4ce2aab2832eb63c$export$5aa84b5b6914a77e(param) {
    var url = param.url, onLoad = param.onLoad, onError = param.onError;
    var _useRegisteredComponentByUrl;
    var registeredComponentId = (_useRegisteredComponentByUrl = (0, $a22BD.useRegisteredComponentByUrl)(url)) === null || _useRegisteredComponentByUrl === void 0 ? void 0 : _useRegisteredComponentByUrl.componentId;
    (0, $9fsm9.default).useEffect(function() {
        return function() {
            if (registeredComponentId) (0, $a22BD.registry).unregister(registeredComponentId);
        };
    }, [
        registeredComponentId
    ]);
    (0, $9fsm9.default).useEffect(function() {
        var _document, _window___MAKER_NAV_SCRIPT_RELOAD_COUNT__;
        if (!((_document = document) === null || _document === void 0 ? void 0 : _document.head)) // Potentially running on the server
        return;
        window.__MAKER_NAV_SCRIPT_RELOAD_COUNT__ = window.__MAKER_NAV_SCRIPT_RELOAD_COUNT__ || {};
        var _window___MAKER_NAV_SCRIPT_RELOAD_COUNT___url;
        window.__MAKER_NAV_SCRIPT_RELOAD_COUNT__[url] = ((_window___MAKER_NAV_SCRIPT_RELOAD_COUNT___url = window.__MAKER_NAV_SCRIPT_RELOAD_COUNT__[url]) !== null && _window___MAKER_NAV_SCRIPT_RELOAD_COUNT___url !== void 0 ? _window___MAKER_NAV_SCRIPT_RELOAD_COUNT___url : -1) + 1;
        var reloadCount = (_window___MAKER_NAV_SCRIPT_RELOAD_COUNT__ = window.__MAKER_NAV_SCRIPT_RELOAD_COUNT__) === null || _window___MAKER_NAV_SCRIPT_RELOAD_COUNT__ === void 0 ? void 0 : _window___MAKER_NAV_SCRIPT_RELOAD_COUNT__[url];
        var script = document.createElement("script");
        script.type = "module";
        script.src = url + (reloadCount == 0 || reloadCount == undefined ? "" : "?v=" + reloadCount);
        document.head.appendChild(script);
        script.onload = function() {
            (0, $jUZe6.log)("component loaded", url);
            onLoad && onLoad();
        };
        script.onerror = function(error) {
            onError && onError("Failed to load remote component");
            console.error("Error loading remote component:", error);
        };
        return function() {
            (0, $jUZe6.log)("component unloaded", url);
            document.head.removeChild(script);
        };
    }, [
        url
    ]);
    return null;
}

});



})();
//# sourceMappingURL=Entrypoint.bs.9120f02b.js.map
